export default __webpack_public_path__ + "static/media/7.c663ba2d.jpg";